var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIkbnLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-11c069a1-6a5f-419b-9a8e-7403598a0295",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 257,
    height: 60,
    viewBox: "0 0 257 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m78.202,14.682h5.733v28.789h-5.733V14.682Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.064,30.296v13.174h-5.408v-12.117c0-2.846-.976-4.107-2.968-4.107-1.708,0-3.497,1.098-5.042,2.643v13.581h-5.408v-20.046h4.798l.244,2.968c1.993-2.236,4.432-3.782,7.401-3.782,4.026,0,6.384,2.724,6.384,7.685Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.814,37.249v-9.637h-3.334v-4.188h3.456v-4.188l4.188-2.521h1.098v6.709h5.489v4.188h-5.489v8.824c0,2.48.732,3.171,2.521,3.171.895,0,1.748-.203,2.562-.61l.407.203.122,4.31c-1.179.488-2.846.773-4.31.773-4.514,0-6.709-2.318-6.709-7.034Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.384,34.85h-13.743c.203,3.212,2.236,5.164,5.205,5.164,2.155,0,4.676-.691,6.628-2.399h.203l.57,4.351c-2.033,1.342-5.002,2.318-7.889,2.318-6.546,0-10.247-4.432-10.247-10.776s3.904-10.897,9.921-10.897c5.937,0,9.393,4.188,9.393,10.612,0,.732,0,.976-.041,1.627Zm-5.042-3.375c-.163-3.09-1.708-4.88-4.148-4.88-2.399,0-4.189,1.83-4.514,4.839l8.661.041Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.102,43.47V13.584h5.408v29.887h-5.408Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.324,43.47V13.584h5.408v29.887h-5.408Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.855,17c0-1.789,1.423-3.131,3.375-3.131s3.375,1.382,3.375,3.131c0,1.789-1.423,3.171-3.375,3.171-1.911,0-3.375-1.383-3.375-3.171Zm.691,26.471v-20.046h5.408v20.046h-5.408Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.594,26.921l10.979,16.346-.122.204h-6.628l-8.092-12.158-3.782,4.351v7.807h-5.733V14.682h5.733v5.001c0,2.724-.122,6.099-.204,8.986h.082c1.749-2.277,3.375-4.391,5.042-6.343l6.465-7.644h6.628l.122.203-10.49,12.036Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.782,34.85h-13.743c.203,3.212,2.236,5.164,5.205,5.164,2.155,0,4.676-.691,6.628-2.399h.203l.57,4.351c-2.033,1.342-5.002,2.318-7.889,2.318-6.546,0-10.247-4.432-10.247-10.776s3.904-10.897,9.921-10.897c5.937,0,9.393,4.188,9.393,10.612,0,.732,0,.976-.041,1.627Zm-5.042-3.375c-.163-3.09-1.708-4.88-4.148-4.88-2.399,0-4.189,1.83-4.514,4.839l8.661.041Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.753,23.424l1.952,6.668c.691,2.155,1.667,5.042,2.317,7.238h.122c.692-2.196,1.749-5.042,2.521-7.198l2.114-6.709h5.855l.163.163-12.117,28.83h-5.53l-.041-.163,4.026-9.352-7.563-19.315.163-.163h6.018Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 57,
    height: 57,
    rx: 7.125,
    ry: 7.125,
    style: {
      fill: "#c3c3c3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.087,
    y: 3.587,
    width: 54.04,
    height: 52.826,
    rx: 6.679,
    ry: 6.679,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.021,
    y: 4.521,
    width: 50.959,
    height: 50.959,
    rx: 6.37,
    ry: 6.37,
    style: {
      fill: "#f6f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23.813,49.225c-.365,0-.734-.114-1.048-.351-2.835-2.137-4.461-5.396-4.461-8.944v-18.857c0-6.173,5.023-11.196,11.197-11.196s11.195,5.023,11.195,11.196v18.857c0,3.546-1.626,6.806-4.458,8.943-.772.583-1.862.426-2.445-.342-.579-.769-.426-1.864.342-2.444,1.951-1.472,3.071-3.716,3.071-6.157v-18.857c0-4.249-3.457-7.707-7.705-7.707s-7.707,3.457-7.707,7.707v18.857c0,2.442,1.12,4.686,3.071,6.157.77.58.924,1.674.344,2.443-.344.455-.866.695-1.396.695Z",
    style: {
      fill: "#075571"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.501,50.124c-.964,0-1.745-.781-1.745-1.745v-10.662c0-.964.78-1.745,1.745-1.745s1.745.781,1.745,1.745v10.662c0,.964-.78,1.745-1.745,1.745Z",
    style: {
      fill: "#075571"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 30.501,
    r: 2.191,
    style: {
      fill: "#075571"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkbnLogo);
export default __webpack_public_path__ + "static/media/IKBNLogo.06bbe8a11a1c3f0d950a9cce0972aec5.svg";
export { ForwardRef as ReactComponent };